// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3B_Cp","label":"Category_label__DcK96","content":"Category_content__3wOZS","header":"Category_header__ySJiH","location":"Category_location__TebgM"};